export default __webpack_public_path__ + "static/transform-vehicle-e310387fc13e2658301bb2e3de5a5abc.webp";